import { useMemo } from 'react';
import { useAppSelector } from '.';
import { getBusinessUnits } from '../reducers/BusinessUnits';
import { hasCustomBusinessUnits, isDefaultBusinessUnit, resetBusinessUnitsLocalStorageIfNeeded } from '../utils/businessUnitsUtils';
import { getCurrentBusinessUnitFromBusinessUnits } from '../utils/getCurrentBusinessUnit';
import { usePortal, useUser } from './useNavConfig';
const useBusinessUnits = () => {
  const {
    portalId
  } = usePortal();
  const {
    scopes
  } = useUser();
  resetBusinessUnitsLocalStorageIfNeeded({
    scopes
  });
  const businessUnits = useAppSelector(getBusinessUnits);
  const currentBusinessUnit = useMemo(() => {
    return getCurrentBusinessUnitFromBusinessUnits({
      businessUnits,
      portalId
    });
  }, [businessUnits, portalId]);
  const shouldDisplayBusinessUnitDisplayText = hasCustomBusinessUnits(businessUnits) && currentBusinessUnit && !isDefaultBusinessUnit(currentBusinessUnit);
  const businessUnitDisplayText = shouldDisplayBusinessUnitDisplayText ? `- ${currentBusinessUnit.name}` : '';
  return {
    businessUnitDisplayText,
    businessUnits,
    currentBusinessUnit
  };
};
export default useBusinessUnits;